import { useMutation } from '@tanstack/react-query';
import { uploadLocalContentProduct } from './uploadLocalContentProduct';
import { useDispatch } from 'react-redux';
import { showNotification, TYPE_ERROR } from '../../../../store/notifications/actions';
import { invalidateYourTitlesProducts } from '../../your-titles/useYourTitlesProducts';
import RoutingUtils from '../../../../shared/utils/utils-routing';
import { PATH_LOCAL_CONTENT } from '../../../../store/constants';
import { useTranslation } from 'react-i18next';

interface ErrorType {
    response: {
        data: {
            message: string;
        };
    };
}

export const useUploadLocalContentProduct = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return useMutation(uploadLocalContentProduct, {
        onSuccess: productId => {
            invalidateYourTitlesProducts().then();
            dispatch(showNotification(t('notifications.useUploadLocalContentProduct.success')));
            RoutingUtils.pushUrl(`${PATH_LOCAL_CONTENT}/products/${productId}`);
        },
        onError: (error: ErrorType) => {
            dispatch(
                showNotification(
                    t('notifications.useUploadLocalContentProduct.error', {
                        message: error.response.data.message
                    }),
                    TYPE_ERROR
                )
            );
        }
    });
};
